import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import Grid from '@mui/material/Grid2';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PeopleIcon from '@mui/icons-material/People';
import InventoryIcon from '@mui/icons-material/Inventory';
import { Box } from '@mui/material';
import { DashboardStats } from '../../interfaces/Dashboard/DashboardStats';
import { getDashboardStats } from '../../api/Dashboard';
import {
  DashboardStatsCard,
  DashboardStatsCardEmpty,
} from '../../components/Dashboard/DashboardStatsCard';
import { ReviewsWidget } from './Widgets/ReviewsWidget';
import { OrdersWidget } from './Widgets/OrdersWidget';
import { RevenueWidget } from './Widgets/RevenueWidget';
import { TotalRevenueCard } from './Widgets/TotalRevenueCard';

const cardSize = { xs: 12, md: 6, xl: 3 };
const tableSize = { xs: 12, lg: 6 };

export const DashboardPage = () => {
  const [stats, setStats] = useState<DashboardStats | undefined>(undefined);

  useEffect(() => {
    getDashboardStats()
      .then((s) => setStats(s))
      .catch((err) => toast.error(err.message));
  }, []);

  return (
    <Grid container spacing={3}>
      <Grid size={cardSize}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          {stats ? (
            <>
              <DashboardStatsCard
                title='Toplam Sipariş'
                icon={
                  <ShoppingCartIcon
                    fontSize='large'
                    sx={{ color: '#6589e2' }}
                  />
                }
                value={stats.totalOrders.toString()}
              />

              <DashboardStatsCard
                title='Toplam Kullanıcı'
                icon={<PeopleIcon fontSize='large' sx={{ color: '#f27a8d' }} />}
                value={stats.totalUsers.toString()}
              />

              <DashboardStatsCard
                title='Toplam Ürün'
                icon={
                  <InventoryIcon fontSize='large' sx={{ color: '#85c8b2' }} />
                }
                value={stats.totalProducts.toString()}
              />
            </>
          ) : (
            <>
              <DashboardStatsCardEmpty />
              <DashboardStatsCardEmpty />
              <DashboardStatsCardEmpty />
            </>
          )}
        </Box>
      </Grid>

      <Grid size={cardSize}>
        {stats ? (
          <TotalRevenueCard stats={stats} />
        ) : (
          <DashboardStatsCardEmpty />
        )}
      </Grid>

      <Grid size={tableSize}>
        <RevenueWidget />
      </Grid>

      <Grid size={tableSize}>
        <ReviewsWidget />
      </Grid>

      <Grid size={tableSize}>
        <OrdersWidget />
      </Grid>
    </Grid>
  );
};
